/**
 * @desc 获取采购订单详情
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<defs.srm.PurchaseOrderDetailInfoRpcResponseDto>;
export function request(pono: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/purchaseOrder/getSrmPurchaseOrderDetailsByNo/${pono}`, {
      method: "GET",

      ...options,
    }),
  );
}
